module.exports = __webpack_public_path__ + "static/media/solwent-logoW.879c85be.png";